import { numericUtil } from '@cmg/common';
import isNil from 'lodash/isNil';

import type { IndicationOfInterest } from '../../graphql/__generated__';
import { PricingType, UnitType } from '../../graphql/__generated__';

function formatIoiValue(ioi: IndicationOfInterest | null) {
  switch (ioi?.unitType) {
    case UnitType.Shares:
      return numericUtil.formatInteger(ioi.shares);
    case UnitType.Dollars:
      return numericUtil.formatCurrencyInMillions(ioi.dollars, true);
    case UnitType.Percentage:
      return numericUtil.formatPercents(ioi.percentage);
    default:
      return null;
  }
}

function formatIoiPricingType(ioi: IndicationOfInterest | null) {
  if (!ioi?.pricingType) {
    return null;
  }

  if (ioi.pricingType === PricingType.Limit) {
    return numericUtil.formatCurrency(ioi.limitPriceUsd);
  }

  return 'Market';
}

export function formatIndicationOfInterest(ioi: IndicationOfInterest | null): string {
  const value = formatIoiValue(ioi);
  const pricingType = formatIoiPricingType(ioi);

  if (isNil(value) || isNil(pricingType)) {
    return '-';
  }

  return `${value} @ ${pricingType}`;
}
